import { useState } from "react";
import { apiKeyHeader } from "../configs/ApiKeys";
import { sendMessage } from "../configs/WebService";
import "./ContactUsPage.css";
export default function ContactUsPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile_number: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const validateForm = () => {
    const errors = [];

    if (!formData.name.trim()) {
      errors.push("Name is required");
    }

    if (!formData.email.trim()) {
      errors.push("Email is required");
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.push("Please enter a valid email address");
    }

    if (!formData.mobile_number.trim()) {
      errors.push("Mobile number is required");
    } else if (!/^[6-9]\d{9}$/.test(formData.mobile_number)) {
      errors.push("Please enter a valid 10-digit mobile number");
    }

    if (!formData.message.trim()) {
      errors.push("Message cannot be empty");
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validateForm();

    if (errors.length > 0) {
      alert(errors.join("\n")); // 🚨 ALERT ALL ERRORS
      return; // STOP API CALL
    }

    setSubmitted(true);

    try {
      const response = await fetch(sendMessage, {
        method: "POST",
        headers: apiKeyHeader(),
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error("Failed to submit form");
      }

      setFormData({
        name: "",
        email: "",
        mobile_number: "",
        message: "",
      });

      alert("Successfully submitted the form");
    } catch (error) {
      alert(error.message || "Something went wrong. Please try again.");
    }

    setTimeout(() => setSubmitted(false), 2000);
  };

  const styles = {
    outer: {
      background: "#fcf7f7f4",
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'Inter', sans-serif",
    },
    card: {
      background: "#fff",
      borderRadius: "16px",
      padding: "2.2rem 2rem",
    },
    cardTitle: {
      fontSize: "1.2rem",
      fontWeight: 600,
      color: "#1a1a2e",
      marginBottom: "1.8rem",
    },
    infoItem: {
      display: "flex",
      alignItems: "flex-start",
      gap: 16,
      padding: 16,
      background: "#f8f9ff",
      borderRadius: 12,
      marginBottom: 14,
      border: "1px solid #ececf8",
    },
    infoIcon: {
      width: 44,
      height: 44,
      borderRadius: "50%",
      //   background: "linear-gradient(135deg, #6b74d6, #8b5ea8)",
      background: "rgb(32,85,223)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },
    infoLabel: {
      fontSize: 14,
      fontWeight: 600,
      color: "#1a1a2e",
      marginBottom: 3,
    },
    infoVal: { fontSize: 13, color: "#6b7280", lineHeight: 1.5 },
    field: { display: "flex", flexDirection: "column", marginBottom: 16 },
    fieldLabel: {
      fontSize: 13,
      fontWeight: 500,
      color: "#1a1a2e",
      marginBottom: 6,
      display: "flex",
      alignItems: "center",
      gap: 4,
    },
    required: { color: "#e53e3e", fontSize: 13 },
    inputWrap: {
      border: "1.5px solid #e2e8f0",
      borderRadius: 8,
      overflow: "hidden",
      background: "#fff",
    },
    inputIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "8px 10px",
      background: "#f1f3ff",
      borderBottom: "1px solid #e2e8f0",
    },
    input: {
      width: "100%",
      padding: "10px 12px",
      border: "none",
      outline: "none",
      fontSize: 13,
      color: "#374151",
      background: "#ffffff",
      fontFamily: "'Inter', sans-serif",
    },
    textarea: {
      width: "100%",
      padding: "10px 12px",
      border: "none",
      outline: "none",
      fontSize: 13,
      color: "#374151",
      background: "#ffffff",
      fontFamily: "'Inter', sans-serif",
      resize: "none",
      lineHeight: 1.6,
    },
    sendBtn: {
      width: "100%",
      padding: 14,
      //   background: "linear-gradient(135deg, #6b74d6, #8b5ea8)",
      background: "rgb(32,85,223)",
      color: "#fff",
      border: "none",
      borderRadius: 10,
      fontSize: 14,
      fontWeight: 600,
      fontFamily: "'Inter', sans-serif",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      marginTop: 4,
    },
    success: {
      marginTop: 12,
      padding: "10px 14px",
      background: "#ecfdf5",
      border: "1px solid #6ee7b7",
      borderRadius: 8,
      color: "#065f46",
      fontSize: 13,
      textAlign: "center",
    },
  };

  const InfoIcon = ({ children }) => (
    <div style={styles.infoIcon}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#fff"
        strokeWidth="1.8"
      >
        {children}
      </svg>
    </div>
  );

  const InputIcon = ({ children }) => (
    <div style={styles.inputIcon}>
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#6b74d6"
        strokeWidth="1.8"
      >
        {children}
      </svg>
    </div>
  );

  return (
    <div>
      <div className="cu-outer" style={styles.outer}>
        <div className="cu-container">
          {/* Contact Info Card */}
          <div style={styles.card}>
            <p style={styles.cardTitle}>Contact Information</p>

            {[
              {
                icon: (
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.68A2 2 0 012 .18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7a2 2 0 011.72 2.03z" />
                ),
                label: "Phone",
                val: "+91 9289440047",
              },
              {
                icon: (
                  <>
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </>
                ),
                label: "Email",
                val: "info@mydocmaster.in",
              },
              {
                icon: (
                  <>
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </>
                ),
                label: "Business Hours",
                val: "Mon - Sat : 9:00 AM – 6:00 PM",
              },
              {
                icon: (
                  <>
                    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </>
                ),
                label: "Address",
                val: "DocMaster\nA 75 Sector 63 Noida - 201301\nUttar Pradesh, India",
              },
            ].map(({ icon, label, val }) => (
              <div key={label} style={styles.infoItem}>
                <InfoIcon>{icon}</InfoIcon>
                <div>
                  <p style={styles.infoLabel}>{label}</p>
                  <p style={styles.infoVal}>
                    {val.split("\n").map((line, i) => (
                      <span key={i}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Form Card */}
          <div style={styles.card}>
            <p style={styles.cardTitle}>Send us a Message</p>

            <form onSubmit={handleSubmit}>
              {/* Name */}
              <div style={styles.field}>
                <div style={styles.fieldLabel}>
                  Name <span style={styles.required}>*</span>
                </div>
                <div style={styles.inputWrap}>
                  <InputIcon>
                    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </InputIcon>
                  <input
                    style={styles.input}
                    type="text"
                    name="name"
                    placeholder="Enter your full name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              {/* Email */}
              <div style={styles.field}>
                <div style={styles.fieldLabel}>
                  Email <span style={styles.required}>*</span>
                </div>
                <div style={styles.inputWrap}>
                  <InputIcon>
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </InputIcon>
                  <input
                    style={styles.input}
                    type="email"
                    name="email"
                    placeholder="your@email.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              {/* Mobile */}
              <div style={styles.field}>
                <div style={styles.fieldLabel}>
                  Mobile <span style={styles.required}>*</span>
                </div>
                <div style={styles.inputWrap}>
                  <InputIcon>
                    <rect x="5" y="2" width="14" height="20" rx="2" />
                    <line x1="12" y1="18" x2="12.01" y2="18" />
                  </InputIcon>
                  <input
                    style={styles.input}
                    type="tel"
                    name="mobile_number"
                    placeholder="+91 XXXXX XXXXX"
                    value={formData.mobile_number}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              {/* Message */}
              <div style={styles.field}>
                <div style={styles.fieldLabel}>
                  Message <span style={styles.required}>*</span>
                </div>
                <div style={styles.inputWrap}>
                  <textarea
                    style={styles.textarea}
                    name="message"
                    rows="4"
                    placeholder="Tell us how we can help you..."
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <button style={styles.sendBtn} type="submit">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="2"
                >
                  <line x1="22" y1="2" x2="11" y2="13" />
                  <polygon points="22 2 15 22 11 13 2 9 22 2" />
                </svg>
                Send Message
              </button>

              {/* {submitted && (
                <div style={styles.success}>
                  Message sent! We'll get back to you soon.
                </div>
              )} */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
